<template>
  <v-app :style="{background: $vuetify.theme.themes.dark.background}">
    <AppBar />
    <SideBar />
    <v-container>
      <v-row>
        <v-col cols="7">
          <Groups />
        </v-col>
        <v-col>
          <ControlPanel />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <Cart />
        </v-col>
        <v-col cols="12" md="3">
          <Numpad />
        </v-col>
        <v-col cols="12" md="5">
          <Products />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import AppBar from '../components/AppBar.vue'
  import SideBar from '../components/SideBar.vue'
  import Groups from '../components/Groups.vue'
  import ControlPanel from '../components/ControlPanel.vue'
  import Products from '../components/Products.vue'
  import Cart from '../components/Cart.vue'
  import Numpad from '../components/Numpad.vue'

  export default {
    name: 'Home',

    components: {
      AppBar,
      SideBar,
      Groups,
      ControlPanel,
      Products,
      Cart,
      Numpad
    },
  }
</script>

<style>
</style>
